import ProductService from './product.service';
import NotificationService from './notification.service';
import AuthService from './auth.service';
import UserService from './user.service';
import RoleService from './role.service';
import HttpService from './http.service';
import SalesService from './sales.service';
import PurchaseService from './purchase.service';
import DashboardService from './dashboard.service';
import SupplierService from './supplier.service';
import CategoryService from './category.service';
import CustomFieldService from './custom-field.service';
import ProductionService from './production.service';
import SettingsService from './settings.service';
import BrandService from './brand.service';
import PlatformService from './platform.service';
import BagService from './bag.service';
import ShippingBoxService from './shipping-box.service';
import CardService from './card.service';
import InventoryService from './inventory.service';
import CoverService from './cover.service';
import FillService from './fill.service';
import ReportService from './report.service';
import InventoryReportService from './inventory-report.service';
import AdjustmentService from './adjustment.service';
import PartTypeService from './part-type.service';
import PartService from './part.service';
import FulfillmentCostService from './fulfillment-cost.service';
import ReturnsService from './returns.service';
import ListingService from './listing.service';
import CostingService from './costing.service';


export const service = {
  product: ProductService(HttpService),
  inventory: InventoryService(HttpService),
  notification: NotificationService,
  auth: AuthService(HttpService),
  user: UserService(HttpService),
  role: RoleService(HttpService),
  dashboard: DashboardService(HttpService),
  sales: SalesService(HttpService),
  purchase: PurchaseService(HttpService),
  supplier: SupplierService(HttpService),
  category: CategoryService(HttpService),
  customField: CustomFieldService(HttpService),
  production: ProductionService(HttpService),
  settings: SettingsService(HttpService),
  bag: BagService(HttpService),
  platform: PlatformService(HttpService),
  brand: BrandService(HttpService),
  shippingBox: ShippingBoxService(HttpService),
  card: CardService(HttpService),
  cover: CoverService(HttpService),
  fill: FillService(HttpService),
  report: ReportService(HttpService),
  inventoryReport: InventoryReportService(HttpService),
  adjustmentService: AdjustmentService(HttpService),
  partType: PartTypeService(HttpService),
  part: PartService(HttpService),
  fulfillmentCost: FulfillmentCostService(HttpService),
  returns: ReturnsService(HttpService),
  listing: ListingService(HttpService),
  costing: CostingService(HttpService),
  https: HttpService,

};
